module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.ef6d6e52.svg";